module.exports = __webpack_public_path__ + "fonts/Barlow-Thin.b9718067.ttf";